import React from 'react';
import PublicStaticPage from './PublicStaticPage';

const Press = () => <PublicStaticPage pageKey="press" />;

export default Press;
